import { z } from "zod";


export const GedDocumentoSchema = z.object({
  statusArquivo: z.coerce.number().default(2),
  tipo: z.coerce.number().default(1),
  arquivo: z.string({ required_error: 'Este campo é obrigatorio!' }).nonempty('Este campo é obrigatorio!'),
  versao: z.string().nullable().default(null),
  centroCusto: z.coerce.number().nullable().default(null),
  revisadoPor: z.coerce.number().nullable().default(null),
  aprovadoPor: z.coerce.number().nullable().default(null),
  responsavelProcesso: z.coerce.number().nullable().default(null),
  localArmazenamento1: z.string().nullable().default(null),
  localArmazenamento2: z.string().nullable().default(null),
  acesso: z.string().nullable().default(null),
  recuperacao: z.string().nullable().default(null),
  protecao: z.string().nullable().default(null),
  retencao: z.string().nullable().default(null),
  disposicao: z.string().nullable().default(null),
  observacoes: z.string().nullable().default(null),
  file: z.instanceof(File).nullable().default(null),
  filePdf: z.instanceof(File).nullable().default(null),
  limparArquivo: z.coerce.boolean().default(false),
  limparArquivoPdf: z.coerce.boolean().default(false),
  revisao: z.coerce.number().default(0),
});


export type GedDocumentoForm = z.infer<typeof GedDocumentoSchema>;